import React, { useState, useEffect } from "react";
import { ModalXoa } from "./ChucNang/ModalXoa";
import { ModalLienKetNganHangMB } from "./ChucNang/ModalLienKetNganHangMB";
import { ModalHuyLienKetNganHangMB } from "./ChucNang/ModalHuyLienKetNganHangMB";
import { ThemMoiCapDuyet } from "./ThemMoiCapDuyet";
import { PopoversBootrap } from "../../../components/GenericComponent/PopoversBootrap";
import { formatNumber, formatMoney } from "utils/currencyFormat";
import { useSelector, useDispatch } from "react-redux";

export const ContentTable = ({ dataDanhSach, onSearch }) => {
  const setModalEdit = (item) => {
    item.onSearch = onSearch;
    setDataFocus(item);
    handleShowEdit();
  };

  const ShowConfirmDelete = (item) => {
    item.onSearch = onSearch;
    setDataFocus(item);
    handleShowEdit();
  };

  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanBank);
  const [dataFocus, setDataFocus] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => setShowEdit(true);
  const [isModalXoa, setModalXoa] = useState(false);
  const toggleModalXoa = () => {
    setModalXoa(!isModalXoa);
  };
  const deleteCap = (item) => {
    setDataFocus(item);
    toggleModalXoa();
  };
  //Phần  lien kết ngân hàng
  const showDangKyPushBDSD = (item) => {
    setDataFocus(item);
    toggleModalLienKet();
  };
  const [isModalLienKet, setModalLienKet] = useState(false);
  const toggleModalLienKet = () => {
    setModalLienKet(!isModalLienKet);
  };
  // end lien kết ngân hàng

  //Phần huy lien kết ngân hàng
  const showHuyDangKyPushBDSD = (item) => {
    setDataFocus(item);
    toggleModalHuyLienKet();
  };
  const [isModalHuyLienKet, setModalHuyLienKet] = useState(false);
  const toggleModalHuyLienKet = () => {
    setModalHuyLienKet(!isModalHuyLienKet);
  };
  // end lien kết ngân hàng

  return (
    <>
      {dataDanhSach.List.map((item, index) => (
        <div className="custom-table-row" key={item.Id}>
          <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
            <span className="mobile-column-name">STT</span>
            <div className="center-wrapper">
              <p className="text-center">
                {(dataSearch.iPageIndex - 1) * dataSearch.iPageSize + index + 1}
              </p>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-20 flex-basis-29-sm  action-cell">
            <span className="mobile-column-name">Tên cấp duyệt</span>
            <div className="center-wrapper">
              <p className="text-left">{item.TenCapDuyet}</p>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-10 flex-basis-20-sm  action-cell">
            <span className="mobile-column-name">Số tiền duyệt</span>
            <div className="center-wrapper">
              <p className="text-right">{formatNumber(item.SoTien)}</p>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-10 flex-basis-20-sm  action-cell">
            <span className="mobile-column-name">Tài khoản</span>
            <div className="center-wrapper">
              <p className="text-left">{item.sUser}</p>
            </div>
          </div>

          <div className="custom-table-cell flex-basis-15 flex-basis-11-4-sm ">
            <span className="mobile-column-name">Thao Tac</span>
            <div
              className="center-wrapper text-center"
              style={{ fontSize: "20px" }}
            >
              <a
                href={() => false}
                onClick={(e) => setModalEdit(item)}
                style={{ marginRight: "5px" }}
              >
                <PopoversBootrap
                  contentText="Sửa"
                  titleText=""
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <img src="/app-assets/images/icon-edit-v2.png" />
                </PopoversBootrap>
              </a>

              <a
                href={() => false}
                onClick={(e) => deleteCap(item)}
                style={{ marginRight: "5px" }}
              >
                <PopoversBootrap
                  contentText="Xóa"
                  titleText=""
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <img
                    style={{ marginLeft: "5px" }}
                    src="/app-assets/images/icon-xoa-v2.png"
                  />
                </PopoversBootrap>
              </a>
            </div>
          </div>
        </div>
      ))}{" "}
      {showEdit && (
        <ThemMoiCapDuyet
          data={dataFocus}
          show={showEdit}
          onHide={handleCloseEdit}
        />
      )}
      <ModalXoa
        isModalVisible={isModalXoa}
        onSearch={onSearch}
        toggleModal={toggleModalXoa}
        item={dataFocus}
      />
    </>
  );
};
